module.exports = __webpack_public_path__ + "assets/img/202107-3W.ed855fab.png";